import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgInvitesCardProps {
    orgId: string;
}

export default function OrgInvitesCard({ orgId }: IOrgInvitesCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="orgInvite"
            title={t('common:organization.canInviteMembers.title')}
            description={t('common:organization.canInviteMembers.description')}>
            <OrgLinks variant="orgInvites" organizationId={orgId} />
        </CardStack>
    );
}
